import { Controller } from '@hotwired/stimulus'
export default class extends Controller {
  captureQuote (event) {
    const quoteInput = event.target.closest('form')?.querySelector('input[name="quote"]')
    if (quoteInput) { quoteInput.value = window.getSelection()?.toString() || '' }
  }

  preventUnselect (event) {
    event.preventDefault()
  }
}
